/* eslint-disable react/forbid-prop-types */
import styled from '@emotion/styled';
import { mediaQuery, Spacings } from '@styles/index';
import P1 from '@base/P1/P1';
import { getIsLoggedIn } from '@api/selectors/auth';
import useMyInfo from '@api/hooks/auth/useMyInfo';
import useFollowedGoals from '@api/hooks/goal/useFollowedGoals';
import { useEffect } from 'react';
import GoalGroupNav from './GoalGroupNav';
import GoalCard from './GoalCard';

const GoalGroupChildren = styled.div`
  display: grid;
  grid-template-columns: repeat(18, 32px);
  grid-column-gap: 16px;
  ${mediaQuery.uptoTablet} {
    grid-template-columns: repeat(18, 1fr);
  }
`;

const WebGoalGroupsContainer = styled.div`
  display: grid;
  width: 1136px;
  grid-template-columns: repeat(24, 1fr);
  ${mediaQuery.uptoMobile} {
    display: none;
  }
`;

const GoalItems = styled.div`
  grid-column: span 18;
  padding-bottom: 350px;
  z-index: 0;
  ${mediaQuery.uptoTablet} {
    padding-bottom: 175px;
    grid-column: span 17;
  }
  ${mediaQuery.uptoMobile} {
    display: none;
  }
`;

const GoalGroupContainer = styled.div`
  margin-bottom: ${Spacings.SPACING_12B};
`;

const WebGoalGroups = ({
  sendOnboardingGoalGroupSelectedEvent,
  setCurrentRefIndex,
  currentRefIndex,
  onGoalGroupClick,
  allGoalGroups,
  onGoalCardClick,
  goalGroupRefs
}) => {
  const isLoggedIn = useMyInfo(getIsLoggedIn);
  const { followedGoals, mutate: fetchFollowedGoals } = useFollowedGoals();

  const hasMultipleGoalGroups = allGoalGroups.length > 1;

  useEffect(() => {
    if (isLoggedIn) {
      fetchFollowedGoals();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn]);

  return (
    <WebGoalGroupsContainer>
      {hasMultipleGoalGroups && (
        <GoalGroupNav
          sendOnboardingGoalGroupSelectedEvent={
            sendOnboardingGoalGroupSelectedEvent
          }
          goalGroups={allGoalGroups}
          setCurrentRefIndex={setCurrentRefIndex}
          currentRefIndex={currentRefIndex}
          onGoalGroupClick={onGoalGroupClick}
        />
      )}
      <GoalItems>
        {allGoalGroups.map((goalGroup, id) => {
          return goalGroup.children.length > 0 ? (
            <GoalGroupContainer
              id={goalGroup.uid}
              className={goalGroup.name}
              // eslint-disable-next-line react/no-array-index-key
              key={`item-${id}-${goalGroup.uid}`}
              ref={goalGroupRefs.current[id]}
            >
              <P1 color="var(--color-text-primary)">{goalGroup.name}</P1>
              <GoalGroupChildren>
                {goalGroup.children.map((goal) => {
                  return (
                    <GoalCard
                      key={`goal-${goal.uid}`}
                      goal={goal}
                      isMyGoal={goalGroup.uid === 'my-goals'}
                      role={`goalcard-${goal.uid}`}
                      onClick={onGoalCardClick}
                      followedGoals={followedGoals}
                    />
                  );
                })}
              </GoalGroupChildren>
            </GoalGroupContainer>
          ) : null;
        })}
      </GoalItems>
    </WebGoalGroupsContainer>
  );
};

export default WebGoalGroups;
